module.exports = __webpack_public_path__ + "static/media/icon_todo.fe3f71e2.svg";